import React, {useEffect, useState} from 'react';
import DeptIcon from '../../../imgs/dashboardicon.svg';
import postIcon from '../../../imgs/post.svg';
import backIcon from '../../../imgs/backIcon.svg';
import bountyIcon from '../../../imgs/bounty.svg';
import {PostIcon} from '../SvgIcons/SvgIcons';
import {useHistory} from 'react-router-dom';
import {Select} from 'antd';
import {gql, useMutation} from '@apollo/client';
import {CREATE_BOUNTY} from '../../../graphql/mutations/bounties';
import {useSelector} from 'react-redux';

const { Option } = Select;

const PostBounty = ({ handleCancel, isVisible}) => {
  const [personBountyState, setPersonBountyState] = useState({
    fullName: '',
    company: '',
    jobTitle: '',
    linkedinUrl: '',
    demandPrice: 0.0,
  });
  const [departmentBountyState, setDepartmentBountyState] = useState({
    departmentCompany: '',
    departmentName: '',
    departmentJobTitle: '',
    reason: 'Business development',
    departmentDemandPrice: 0.0,
  });

  const userProfile = useSelector((state) => state.strapiRes);

  const [loader, setLoader] = useState(false);

  const history = useHistory();

  const [createBounty] = useMutation(gql(CREATE_BOUNTY));

  const {fullName, company, jobTitle, linkedinUrl, demandPrice} =
    personBountyState;

  const {
    departmentCompany,
    departmentDemandPrice,
    departmentJobTitle,
    departmentName,
    reason,
  } = departmentBountyState;

  const steps = [
    {
      content: (
        <div className="bounty-modal-wrapper first-page">
          <h1 className="heading">Introduce me to a</h1>
          <button className="btn-style" onClick={() => next()}>
            <img src={postIcon} alt="postIcon" />
            Person
          </button>
          <button className="btn-style" onClick={() => moveDepartment()}>
            <img src={DeptIcon} alt="DeptIcon" />
            Department
          </button>
        </div>
      ),
    },
    {
      content: (
        <div className="bounty-modal-wrapper">
          <div className="feed-card-wrapper heights">
            <button className="back-icon" onClick={() => prev()}>
              <img src={backIcon} alt="backIcon" />
              Back
            </button>
            <div className="pb-4" >
              <div className="row m-0 justify-content-between">
                <h2 className="heading">
                  <img src={postIcon} alt="logo" />
                  Person bounty
                </h2>
              </div>
              <p>
                Post a person bounty to get introduced to a specific person.
              </p>
            </div>
          </div>
          <div className="form-details">
            <div className="input-field">
              <label>Full name</label>
              <input
                type="text"
                placeholder="Full Name"
                name="fullName"
                value={fullName}
                onChange={(event) =>
                  setPersonBountyState({
                    ...personBountyState,
                    [event.target.name]: event.target.value,
                  })
                }
              />
            </div>
            <div className="input-field">
              <label>Job title</label>
              <input
                type="text"
                placeholder="Job title"
                name="jobTitle"
                value={jobTitle}
                onChange={(event) =>
                  setPersonBountyState({
                    ...personBountyState,
                    [event.target.name]: event.target.value,
                  })
                }
              />
            </div>
            <div className="input-field">
              <label>Company</label>
              <input
                type="text"
                placeholder="Company"
                name="company"
                value={company}
                onChange={(event) =>
                  setPersonBountyState({
                    ...personBountyState,
                    [event.target.name]: event.target.value,
                  })
                }
              />
            </div>
            <div className="input-field">
              <label>LinkedIn profile</label>
              <input
                type="text"
                placeholder="https://www.linkedin/in/jamesbond"
                name="linkedinUrl"
                value={linkedinUrl}
                onChange={(event) =>
                  setPersonBountyState({
                    ...personBountyState,
                    [event.target.name]: event.target.value,
                  })
                }
              />
            </div>
            <div className="input-field">
              <label>How much are you offering for the intro?</label>
              <div className="logo-box">
                <span>$</span>
                <input
                  type="text"
                  placeholder="1,000"
                  name="demandPrice"
                  value={demandPrice}
                  onChange={(event) =>
                    setPersonBountyState({
                      ...personBountyState,
                      [event.target.name]: event.target.value,
                    })
                  }
                />
              </div>
            </div>
            <button className="btn-style" onClick={() => handlePostBounty()}>
              <PostIcon />
              Post bounty
            </button>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div className="bounty-modal-wrapper">
          <div className="feed-card-wrapper heights">
            <button className="back-icon" onClick={() => departmentPrevious()}>
              <img src={backIcon} alt="backIcon" />
              Back
            </button>
            <div>
              <div className="row m-0 justify-content-between">
                <h2 className="heading">
                  <img src={DeptIcon} alt="logo" />
                  Department bounty
                </h2>
              </div>
              <p>
                Post a department bounty to get introduced to a company or a
                department in a company.
              </p>
            </div>
          </div>
          <div className="form-details">
            <div className="input-field">
              <label>Company</label>
              <input
                type="text"
                placeholder="Space X"
                value={departmentCompany}
                name="departmentCompany"
                onChange={(event) =>
                  setDepartmentBountyState({
                    ...departmentBountyState,
                    [event.target.name]: event.target.value,
                  })
                }
              />
            </div>
            <div className="input-field">
              <label>Department name</label>
              <input
                type="text"
                placeholder="Manufacturing"
                name="departmentName"
                value={departmentName}
                onChange={(event) =>
                  setDepartmentBountyState({
                    ...departmentBountyState,
                    [event.target.name]: event.target.value,
                  })
                }
              />
            </div>
            <div className="input-field">
              <label>Job title(s) you’re after</label>
              <input
                type="text"
                placeholder="Directors, Executives"
                value={departmentJobTitle}
                name="departmentJobTitle"
                onChange={(event) =>
                  setDepartmentBountyState({
                    ...departmentBountyState,
                    [event.target.name]: event.target.value,
                  })
                }
              />
            </div>
            <div className="input-field">
              <label>Reason for the intro</label>
              <Select
                value={reason}
                defaultValue="Business development"
                onChange={(value) =>
                  setDepartmentBountyState({
                    ...departmentBountyState,
                    reason: value,
                  })
                }>
                <Option value="Business development">
                  Business development
                </Option>
                <Option value="Recruiting">Recruiting</Option>
                <Option value="Seeking investment">Seeking investment</Option>
                <Option value="General networking">General networking</Option>
              </Select>
            </div>
            <div className="input-field">
              <label>How much are you offering for the intro?</label>
              <div className="logo-box">
                <span>$</span>
                <input
                  type="text"
                  placeholder="1,100"
                  value={departmentDemandPrice}
                  name="departmentDemandPrice"
                  onChange={(event) =>
                    setDepartmentBountyState({
                      ...departmentBountyState,
                      [event.target.name]: event.target.value,
                    })
                  }
                />
              </div>
            </div>
            <button className="btn-style" onClick={() => handlePostBounty()}>
              <PostIcon />
              Post bounty
            </button>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div className="bounty-modal-wrapper submit-wrapper">
          <div className="center-content">
            <img src={bountyIcon} alt="bountyIcon" className="icon" />
            <h2 className="heading">You have posted a bounty!</h2>
            <p>Offers to introduction may happen any second now.</p>
          </div>
          <button className="btn-style" onClick={() => moveToDashBoard()}>
            Back to dashboard
          </button>
        </div>
      ),
    },
  ];

  const [current, setCurrent] = useState(0);
  const [profileId, setProfileId] = useState('');

  const getProfileId = async () => {
    const value = await localStorage.getItem('profileId');
    setProfileId(value);
  };

  useEffect(() => {
    getProfileId();
  }, [profileId]);

  const handlePostBounty = () => {
    const {fullName, jobTitle, linkedinUrl, demandPrice, company} =
      personBountyState;
    const {
      departmentName,
      departmentJobTitle,
      departmentDemandPrice,
      departmentCompany,
      reason,
    } = departmentBountyState;
    if (
      (fullName && jobTitle && company && linkedinUrl && demandPrice) ||
      (departmentName && departmentJobTitle && reason && departmentDemandPrice)
    ) {
      setLoader(true);
      createBounty({
        variables: {
          profileId: profileId || userProfile?.id,
          bountyType: current === 1 ? 'person' : 'company',
          fullName: fullName || '',
          company: company || departmentCompany,
          department: departmentName || '',
          title: jobTitle || departmentJobTitle,
          linkedinURL: linkedinUrl || '',
          demandPrice:
            parseFloat(demandPrice) || parseFloat(departmentDemandPrice),
          reason: reason || '',
        },
      }).then((res) => {
        setLoader(false);
        finalPage();
        setPersonBountyState({
          fullName: '',
          company: '',
          demandPrice: '',
          jobTitle: '',
          linkedinUrl: '',
        });
        setDepartmentBountyState({
          departmentCompany: '',
          departmentDemandPrice: '',
          reason: '',
          departmentName: '',
          departmentJobTitle: '',
        });
      });
    }
  };

  const strapiRes = useSelector(state => state.strapiRes)

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };
  const departmentPrevious = () => {
    setCurrent(0)
  }

  const moveDepartment = () => {
    setCurrent(2);
  };

  const finalPage = () => {
    setCurrent(3);
  };

  const moveToDashBoard = () => {
    setCurrent(0);
    handleCancel();
    history.push(`/${strapiRes.userName}`);
  };

  return <div className="steps-content">{steps[current]?.content}</div>;
};

export default PostBounty;
